import { Channel } from '../Channel';
export var PivotRootLevel;
(function (PivotRootLevel) {
    PivotRootLevel["ROOT"] = "ROOT";
    PivotRootLevel["LAYER"] = "LAYER";
})(PivotRootLevel || (PivotRootLevel = {}));
export var PivotNodeType;
(function (PivotNodeType) {
    PivotNodeType["ROOT"] = "ROOT";
    PivotNodeType["LAYER"] = "LAYER";
    PivotNodeType["DIMENSION"] = "DIMENSION";
    PivotNodeType["MEASURE"] = "MEASURE";
    PivotNodeType["NAMES"] = "NAMES";
    PivotNodeType["VALUES"] = "VALUES";
})(PivotNodeType || (PivotNodeType = {}));
export class PivotNode {
    constructor() {
        this._children = new Map();
    }
    get parent() {
        return null;
    }
    get children() {
        return this._children;
    }
    getChild(name) {
        return this.children.get(name);
    }
    setChild(name, node) {
        this.children.set(name, node);
    }
}
export class RootNode extends PivotNode {
    get type() {
        return PivotNodeType.ROOT;
    }
    get level() {
        return PivotRootLevel.ROOT;
    }
}
export class LayerRootNode extends PivotNode {
    constructor(parent) {
        super();
        this._parent = parent;
    }
    get type() {
        return PivotNodeType.ROOT;
    }
    get level() {
        return PivotRootLevel.LAYER;
    }
    get parent() {
        return this._parent;
    }
}
export class LayerNode extends PivotNode {
    constructor(parent, name) {
        super();
        this._parent = parent;
        this._name = name;
    }
    get type() {
        return PivotNodeType.LAYER;
    }
    get parent() {
        return this._parent;
    }
    get name() {
        return this._name;
    }
}
export class BaseNode extends PivotNode {
    constructor(parent, channel) {
        super();
        this._parent = parent;
        this._channel = channel;
    }
    get parent() {
        return this._parent;
    }
    get channel() {
        return this._channel;
    }
}
export class DimensionNode extends BaseNode {
    constructor(parent, channel, field, value) {
        super(parent, channel);
        this._field = field;
        this._value = value;
    }
    get type() {
        return PivotNodeType.DIMENSION;
    }
    get field() {
        return this._field;
    }
    get value() {
        return this._value;
    }
}
export class MeasureNode extends BaseNode {
    constructor(parent, channel) {
        super(parent, channel);
        this._scopes = new Map();
        this._baseFields = new Map();
        this._layerFields = new Map();
        this.baseFields.set(Channel.ROW, new Array());
        this.baseFields.set(Channel.COLUMN, new Array());
        this.baseFields.set(Channel.VALUE, new Array());
        // TODO: collapse these into less allocations
        this.layerFields.set(Channel.COLOR, new Array());
        this.layerFields.set(Channel.SIZE, new Array());
        this.layerFields.set(Channel.TEXT, new Array());
        this.layerFields.set(Channel.DETAIL, new Array());
        this.layerFields.set(Channel.TOOLTIP, new Array());
        this.layerFields.set(Channel.ANGLE, new Array());
        this.layerFields.set(Channel.PATH, new Array());
    }
    get type() {
        return PivotNodeType.MEASURE;
    }
    get scopes() {
        return this._scopes;
    }
    get baseFields() {
        return this._baseFields;
    }
    get layerFields() {
        return this._layerFields;
    }
    addField(channel, field) {
        let scope = this.scopes.get(field.alias);
        if (scope === undefined) {
            scope = {};
            this.scopes.set(field.alias, scope);
            switch (channel) {
                case Channel.ROW:
                case Channel.COLUMN:
                case Channel.VALUE:
                    this.baseFields.get(channel).push(field);
                    break;
                default:
                    this.layerFields.get(channel).push(field);
            }
            if (field.type === 'VIEWCALC') {
                if (field.formula.expr.type === 'AGG') {
                    field.formula.expr.init(scope);
                }
            }
        }
    }
    getResult(field) {
        return this.scopes.get(field.alias);
    }
    collect(row) {
        let scope = null;
        for (const [channel, fields] of Array.from(this.baseFields)) {
            for (const field of fields) {
                scope = this.scopes.get(field.alias);
                if (field.type === 'VIEWCALC' && field.formula.expr.type === 'AGG') {
                    scope.row = row;
                    field.formula.expr.step(scope);
                }
            }
        }
        for (const [channel, fields] of Array.from(this.layerFields)) {
            for (const field of fields) {
                scope = this.scopes.get(field.alias);
                if (field.type === 'VIEWCALC' && field.formula.expr.type === 'AGG') {
                    scope.row = row;
                    field.formula.expr.step(this.scopes.get(field.alias));
                }
            }
        }
    }
    reduce() {
        let scope = null;
        for (const [channel, fields] of Array.from(this.baseFields)) {
            for (const field of fields) {
                if (field.type === 'VIEWCALC' && field.formula.expr.type === 'AGG') {
                    scope = this.scopes.get(field.alias);
                    this.scopes.set(field.alias, field.formula.expr.final(scope));
                }
            }
        }
        for (const [channel, fields] of Array.from(this.layerFields)) {
            for (const field of fields) {
                if (field.type === 'VIEWCALC' && field.formula.expr.type === 'AGG') {
                    scope = this.scopes.get(field.alias);
                    this.scopes.set(field.alias, field.formula.expr.final(scope));
                }
            }
        }
    }
}
/**
 * System Fields
 */
export class NamesNode extends BaseNode {
    constructor(parent, channel, field) {
        super(parent, channel);
        this._field = field;
    }
    get type() {
        return PivotNodeType.NAMES;
    }
    get field() {
        return this._field;
    }
}
export class ValuesNode extends BaseNode {
    constructor(parent, channel, field) {
        super(parent, channel);
        this._field = field;
    }
    get type() {
        return PivotNodeType.VALUES;
    }
    get field() {
        return this._field;
    }
}
